
// DO NOT CHANGE WITHOUT CONSULTING THE TEAM
// Locale with underscore format, to match the CWP metadata og:locale
export enum Country {
	default = 'default',
	en_GB = 'en_GB',
	en_US = 'en_US',
	en_CH = 'en_CH',
	en_DE = 'en_DE',
	en_BE = 'en_BE',
	en_DK = 'en_DK',
	en_FR = 'en_FR',
	en_NL = 'en_NL',
	en_NO = 'en_NO',
	en_EE = 'en_EE',
	en_ES = 'en_ES',
	en_FI = 'en_FI',
	en_GR = 'en_GR',
	en_LI = 'en_LI',
	en_LT = 'en_LT',
	en_LU = 'en_LU',
	en_LV = 'en_LV',
	en_PL = 'en_PL',
	en_PT = 'en_PT',
	en_SE = 'en_SE',
	en_AU = 'en_AU',
	en_IE = 'en_IE',
	en_MT = 'en_MT',
	en_IT = 'en_IT',
	en_AT = 'en_AT',
	en_CZ = 'en_CZ',
	en_SK = 'en_SK'
}

export enum LocaleToCountry {
	'en-gb' = Country.en_GB,
	'en-ch' = Country.en_CH,
	'en-de' = Country.en_DE,
	'en-be' = Country.en_BE,
	'en-dk' = Country.en_DK,
	'en-fr' = Country.en_FR,
	'en-nl' = Country.en_NL,
	'en-no' = Country.en_NO,
	'en-ee' = Country.en_EE,
	'en-es' = Country.en_ES,
	'en-fi' = Country.en_FI,
	'en-gr' = Country.en_GR,
	'en-li' = Country.en_LI,
	'en-lt' = Country.en_LT,
	'en-lu' = Country.en_LU,
	'en-lv' = Country.en_LV,
	'en-pl' = Country.en_PL,
	'en-pt' = Country.en_PT,
	'en-se' = Country.en_SE,
	'en-au' = Country.en_AU,
	'en-ie' = Country.en_IE,
	'en-mt' = Country.en_MT,
	'en-it' = Country.en_IT,
	'en-at' = Country.en_AT,
	'en-cz' = Country.en_CZ,
	'en-sk' = Country.en_SK
};
